import { useQuery } from '@tanstack/react-query';
import type { paths } from '../../../generated/apiClient';
import { repositoryGetter } from '../../../repository/container';
import { UseQueryDefaultOptions } from '../common';

const repository = repositoryGetter.Member();
const apiPath: Extract<keyof paths, '/member/list-in-project'> = '/member/list-in-project';
export const queryKey = (props: Props) => [apiPath, props];

type Props = { projectId: string };

export const _listInProject = (props: Props) => {
  const { projectId } = props;

  const { data, isPending, refetch } = useQuery({
    queryKey: queryKey(props),
    queryFn: async ({ signal }) => {
      return repository.listInProject({ projectId, signal });
    },
    ...UseQueryDefaultOptions,
    // 5 min
    staleTime: 1000 * 60 * 5,
    // 10 min
    gcTime: 1000 * 60 * 10,
    enabled: projectId !== undefined,
  });

  return { members: data || [], isPending, refetch };
};
